/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is hashing the same as encryption?`)
};

const es_hg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es el hash lo mismo que la cifración?`)
};

const de_hg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Hashing dasselbe wie Verschlüsselung?`)
};

const nl_hg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is hashing hetzelfde als encryptie?`)
};

const fr_hg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le hachage est-il identique au chiffrement ?`)
};

const it_hg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'hashing è lo stesso della crittografia?`)
};

const pt_br2_hg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash é o mesmo que criptografia?`)
};

const pt_hg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O hashing é o mesmo que encriptação?`)
};

const ja_hg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハッシュ化は暗号化と同じですか?`)
};

const zh_hg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哈希和加密是一回事吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hg_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hg_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hg_faq4_q", locale)
	if (locale === "en") return en_hg_faq4_q(inputs)
	if (locale === "es") return es_hg_faq4_q(inputs)
	if (locale === "de") return de_hg_faq4_q(inputs)
	if (locale === "nl") return nl_hg_faq4_q(inputs)
	if (locale === "fr") return fr_hg_faq4_q(inputs)
	if (locale === "it") return it_hg_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_hg_faq4_q(inputs)
	if (locale === "pt") return pt_hg_faq4_q(inputs)
	if (locale === "ja") return ja_hg_faq4_q(inputs)
	return zh_hg_faq4_q(inputs)
};